module.exports = require('./ElasticSearchSummaryView');
